module.exports = require('./ElasticSearchSummaryView');
